<script>
    import fetchNodeProduction from "../../helpers/FetchNodeProduction";
    import { modalReservation, User } from "../../store";
    
    export let errorsNotification = [];
    export let messageNotification = '';

    export let errorsConfirmation = [];
    export let messageConfirmation = '';

    let loadingConfirmation = false, loadingNotification = false;

    // Global variables
    let emailMessage = '';
    let reservationId;

    modalReservation.subscribe((value) => {
        reservationId = value.id;
    });

    // Generate Notification
    async function submitNotificationForm() {
        try {
            // Access data via FormData
            const formData = new FormData(document.getElementById('bookingNotificationForm'));
            
            // Initialize
            loadingNotification = true; errorsNotification = []; messageNotification = '';

            // Validate if there is any option checked
            if (formData.get('sendHost') !== 'yes' && formData.get('sendAdmin') !== 'yes') {
                errorsNotification.push('Please select at either Admin or Host');
            }

            if (errorsNotification.length === 0) {
                formData.append('message', emailMessage);

                const response = await fetchNodeProduction('/sendNewReservationEmail', formData);

                if (typeof response === 'object') {
                    if (response.action === 'route200') {
                        messageNotification = parseMessage(response);
                    } else {
                        errorsNotification.push(parseMessage(response));
                    }
                }
            }
            emailMessage = ''
            document.getElementById("checkboxHost").checked = false;
            document.getElementById("checkboxAdmin").checked = false;
        } catch (ex) {
            console.log(ex);
        } finally {
            loadingNotification = false;
        }
    };

    // Generate Confirmation
    async function submitConfirmationForm() {
        try {
            const formData = new FormData(document.getElementById('bookingConfirmationForm'));

            loadingConfirmation = true; errorsConfirmation = []; messageConfirmation = '';

            // Validate if there is any option checked
            if (formData.get('sendGuest') !== 'yes' && formData.get('sendAdmin') !== 'yes') {
                errorsConfirmation.push('Please select at either Admin or Guest');
            }

            if (errorsConfirmation.length === 0) {
                formData.append('message', emailMessage);

                const response = await fetchNodeProduction('/sendNewReservationEmail', formData);

                if (typeof response === 'object') {
                    if (response.action === 'route200') {
                        messageConfirmation = parseMessage(response);
                    } else {
                        errorsConfirmation.push(parseMessage(response));
                    }
                }
            }
            emailMessage = ''
            document.getElementById("checkboxGuest").checked = false;
            document.getElementById("checkboxAdmin2").checked = false;
        } catch (ex) {
            console.log(ex);
        } finally {
            loadingConfirmation = false;
        }
    };

    const parseMessage = function (data) {
        const { message } = data;

        if (message === 'token expired') {
            User.logout();
        }

        if (message.hasOwnProperty('part1')) {
            return `${message.part1 || ""} 
                ${message.part2 || ""} 
                ${message.part3 || ""} 
                ${message.part4 || ""}`;
        }

        return message;
    };
</script>
<div class="scrollable max-half-screen">

<div class="form-control">
    <label for="message">Message</label>
    <textarea name="message" rows="3" placeholder="Comments to add to e-mail" bind:value={emailMessage}></textarea>
</div>

<form id="bookingNotificationForm" on:submit|preventDefault={submitNotificationForm}>
    <h3>Booking Notification</h3>
    <hr >

    <input type="hidden" name="reservationId" bind:value={reservationId}>
    <input type="hidden" name="emailType" value="notification">

    <div class="form-control-row">
        <input type="checkbox" name="sendAdmin" value="yes" id="checkboxAdmin"> 
        <label for="sendAdmin">To Admin</label>
    </div>

    <div class="form-control-row">
        <input type="checkbox" name="sendHost" value="yes" id="checkboxHost">
        <label for="sendHost">To Host</label>
    </div>

    <button type="submit" class="pink-button" disabled={loadingNotification}>
        {loadingNotification ? 'Loading...' : 'Send Notification' }
    </button>

    <p>
        <small>
            <strong>
                {#if errorsNotification.length > 0}
                    {#each errorsNotification as error}
                        <span class="red-font">{error}</span><br>
                    {/each}
                {/if}
                {#if messageNotification}
                    <span class="blue-font">{messageNotification}</span><br>
                {/if}
            </strong>
        </small> 
     </p>
</form>

<form id="bookingConfirmationForm" on:submit|preventDefault={submitConfirmationForm}>
    <h3>Guest Confirmation</h3>
    <hr>

    <input type="hidden" name="reservationId" bind:value={reservationId}>
    <input type="hidden" name="emailType" value="confirmation">

    <div class="form-control-row">
        <input type="checkbox" name="sendAdmin" value="yes" id="checkboxAdmin2">
        <label for="sendAdmin">To Admin</label>
    </div>

    <div class="form-control-row">
        <input type="checkbox" name="sendGuest" value="yes" id="checkboxGuest">
        <label for="sendGuest">To Guest</label>
    </div>

    <div class="form-control-row">
        <input type="checkbox" name="generatePaymentLink" value="yes">
        <label for="generatePaymentLink">Send Stripe Payment Link</label>
    </div>

    <button type="submit" class="pink-button" disabled={loadingConfirmation}>
        {loadingConfirmation ? 'Loading...' : 'Send Confirmation' }
    </button>

    <p>
        <small>
            <strong>
                 {#if errorsConfirmation.length > 0}
                     {#each errorsConfirmation as error}
                         <span class="red-font">{error}</span><br>
                     {/each}
                 {/if}
                 {#if messageConfirmation}
                     <span class="blue-font">{messageConfirmation}</span><br>
                 {/if}
            </strong>
        </small> 
     </p>
</form>
</div>
<style>
    form {
        margin: 1em auto;
    }

    h3 {
        margin: 0.5em 0em;;
    }

    hr {
        margin-bottom: 0em;
    }

    .pink-button {
      background-color: #ed4368;
      color: #fff;
      margin-top: 10px;
      width: 100%;
    }

    .pink-button:disabled {
        background-color: #c43c59 !important;
        cursor: not-allowed;
    }
    
    .red-font {
      color: rgb(194, 32, 32);
    }

    .form-control-row {
      display:flex;
      flex:1;
      flex-direction: row;
      padding-top: 15px;
    }
    
    input[type=checkbox]{
      margin-right: 15px;
    }
  
    .form-control {
      display:flex;
      flex:1;
      flex-direction: column;
      padding-top: 15px;
  
    }
    
    .form-control label{
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .scrollable {
      overflow: auto;
      white-space: nowrap;
      padding-right: 20px;
    }
    .max-half-screen {
      max-height: 50vh;
    }
  </style>
  